import React, { useState, useEffect } from 'react';
import SidebarLayout from "components/Layout/Layout";
import './style.scss';
import { API_URL } from "env";
import { Editor } from '@tinymce/tinymce-react';
import { useNavigate } from 'react-router-dom';
import { PencilSimpleIcon, TrashSimpleIcon } from '@phosphor-icons/react'
import { MagnifyingGlassIcon } from "@phosphor-icons/react";
import { Modal } from 'antd';

const MyDailyReading: React.FC = () => {
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const [currentPage, setCurrentPage] = useState(() => {
        const data = sessionStorage.getItem('coachDailyPage');
        return data ? Number(data) : 1;
    });
    const [lastPage, setLastPage] = useState(1);
    const [theme, setTheme] = useState("light");
    const [countEnter, setCountEnter] = useState(0)
    const [countEnter2, setCountEnter2] = useState(0)
    const [searchText, setSearchText] = useState('');
    const [selectedType, setSelectedType] = useState<string | undefined>(undefined);
    const [selectedNumber, setSelectedNumber] = useState<string | undefined>(undefined);

    useEffect(() => {
        if (searchText) {
            sessionStorage.setItem('searchCoachDaily', searchText)
        }
        setCountEnter2(countEnter2 + 1)
    }, [searchText])

    useEffect(() => {
        if (countEnter > 0) {
            fetchData(1);
        }
    }, [searchText]);

    const clickPagination = (key: number) => {
        setCurrentPage(key)
        sessionStorage.setItem('coachDailyPage', JSON.stringify(key))
    }

    useEffect(() => {
        const data = sessionStorage.getItem('coachDailyPage');
        if (data) {
            setCurrentPage(Number(data));
        } else {
            setCurrentPage(1);
        }
        fetchData(currentPage);
    }, []);

    useEffect(() => {
        const searchKey = sessionStorage.getItem('searchCoachDaily');

        if (searchKey) {
            sessionStorage.removeItem('searchCoachDaily')

            if (countEnter2 > 0) {
                setCountEnter2(countEnter2 - 1)
                fetchData(currentPage);
            } else {
                fetchData(1);
            }
        } else {
            if (typeof currentPage === 'number' && countEnter2 > 0) {
                fetchData(currentPage);
            }
        }
        setCountEnter(countEnter + 1)
    }, [currentPage])

    const fetchData = async (page = 1, perPage = 10) => {
        try {
            setLoading(true);

            let url = `${API_URL}api/v1/be/coaching-daily-personal?per_page=${perPage}&page=${page}`;

            if (searchText.trim()) {
                url += `&birthday=${encodeURIComponent(searchText.trim())}`;
            }

            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });

            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            const json = await response.json();

            setData(json.data.items || []);
            setCurrentPage(json.data?.current_page || 1);
            const lastPage = json.data.total % 10 > 0 ? Math.ceil(json.data.total / 10) : json.data.total / 10
            setLastPage(lastPage || 1);
        } catch (err) {
            console.error("Lỗi khi gọi API:", err);
        } finally {
            setLoading(false);
        }
    };

    const handleDelete = async (id: number) => {
        Modal.confirm({
            title: "Xác nhận",
            content: "Bạn có chắc muốn xóa mục này không?",
            okText: "Xóa",
            cancelText: "Hủy",
            okButtonProps: { danger: true }, // nút Xóa màu đỏ
            onOk: async () => {
                try {
                    setLoading(true);
                    const response = await fetch(`${API_URL}api/v1/be/coaching-daily-personal/${id}`, {
                        method: "DELETE",
                        headers: {
                            "Content-Type": "application/json",
                            Authorization: `Bearer ${localStorage.getItem("token")}`,
                        },
                    });

                    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);

                    const json = await response.json();

                    if (json.status) {
                        Modal.success({
                            title: "Thành công",
                            content: "Xóa thành công!",
                        });
                        await fetchData(currentPage);
                    } else {
                        Modal.error({
                            title: "Thất bại",
                            content: "Xóa thất bại: " + (json.message || "Unknown error"),
                        });
                    }
                } catch (error: any) {
                    Modal.error({
                        title: "Lỗi",
                        content: "Lỗi khi xóa: " + error.message,
                    });
                } finally {
                    setLoading(false);
                }
            },
        });
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchText(e.target.value);
    };

    const clearAllFilters = () => {
        setSearchText('');
        setSelectedType(undefined);
        setSelectedNumber(undefined);
    };

    return (
        <SidebarLayout
            title={<h4 className="text-2xl font-bold !m-0 py-4">My Coach Daily</h4>}
        >
            <div className="table-header-daily">
                <div className="flex flex-row w-3/4 gap-4">
                    <div className="relative w-64 bg-white rounded" >
                        <span className="absolute inset-y-0 left-0 flex items-center pl-2 text-gray-400">
                            <MagnifyingGlassIcon className="h-5 w-5" />
                        </span>
                        <input
                            type="text"
                            placeholder="Search..."
                            value={searchText}
                            onChange={handleSearchChange}
                            className="w-full pl-8 pr-2 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
                        />
                    </div>

                    {(searchText) && (
                        <button
                            className="btn-clear-filters"
                            onClick={clearAllFilters}
                            style={{
                                padding: '8px 16px',
                                backgroundColor: '#f5f5f5',
                                border: '1px solid #ddd',
                                borderRadius: '4px',
                                cursor: 'pointer'
                            }}
                        >
                            Clear Filters
                        </button>
                    )}
                </div>

                <button
                    className="btn-add-daily w-1/4"
                    onClick={() => navigate('/add-coach-daily')}
                >
                    + Add
                </button>
            </div>

            <div className="table-wrapper-daily">
                {loading ? (
                    <p>Đang tải dữ liệu...</p>
                ) : (
                    <>
                        <table className="custom-table-daily">
                            <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Type</th>
                                    <th>Number</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.length > 0 ? (
                                    data.map((item, index) => (
                                        <tr key={item.id || index}>
                                            <td>{item.id}</td>
                                            <td>{item.type}</td>
                                            <td>{item.number}</td>
                                            <td>
                                                <div className="action-menu-daily flex gap-2">
                                                    <p
                                                        onClick={() => navigate(`/coach-daily/edit/${item.id}`)}
                                                        className="cursor-pointer p-2 rounded-[5px] m-0 hover:text-blue-700 hover:bg-blue-200 transition-all duration-500 flex items-center justify-center"
                                                    >
                                                        <PencilSimpleIcon size={18} fill={theme === 'dark' ? '#fff' : ''} />
                                                    </p>
                                                    <p
                                                        onClick={() => handleDelete(item.id)}
                                                        className="cursor-pointer p-2 rounded-[5px] m-0 text-red-700 hover:bg-red-200 transition-all duration-500 flex items-center justify-center"
                                                    >
                                                        <TrashSimpleIcon size={18} fill={theme === 'dark' ? '#fff' : ''} />
                                                    </p>
                                                </div>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={4} style={{ textAlign: "center" }}>
                                            {(selectedType || selectedNumber || searchText)
                                                ? "Không tìm thấy kết quả phù hợp với bộ lọc"
                                                : "Không có dữ liệu"
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>

                        {/* Pagination */}
                        {lastPage > 1 && (
                            <div style={{ marginTop: "20px", display: "flex", justifyContent: "center", gap: "5px" }}>
                                <button
                                    onClick={() => clickPagination(Number(currentPage) > 0 ? Number(currentPage) - 1 : 0)}
                                    disabled={Number(currentPage) === 1}
                                    style={{
                                        padding: "5px 10px",
                                        border: "1px solid #ccc",
                                        backgroundColor: Number(currentPage) === 1 ? "#f5f5f5" : "white",
                                        cursor: Number(currentPage) === 1 ? "not-allowed" : "pointer"
                                    }}
                                >
                                    « Prev
                                </button>
                                {Array.from({ length: lastPage }, (_, i) => (
                                    <button
                                        key={i + 1}
                                        onClick={() => clickPagination(i + 1)}
                                        style={{
                                            fontWeight: Number(currentPage) === i + 1 ? "bold" : "normal",
                                            background: Number(currentPage) === i + 1 ? "#1677ff" : "white",
                                            color: Number(currentPage) === i + 1 ? "white" : "black",
                                            padding: "5px 10px",
                                            border: "1px solid #ccc",
                                            cursor: "pointer"
                                        }}
                                    >
                                        {i + 1}
                                    </button>
                                ))}
                                <button
                                    onClick={() => clickPagination(Number(currentPage) + 1)}
                                    disabled={Number(currentPage) === Number(lastPage)}
                                    style={{
                                        padding: "5px 10px",
                                        border: "1px solid #ccc",
                                        backgroundColor: Number(currentPage) === lastPage ? "#f5f5f5" : "white",
                                        cursor: Number(currentPage) === Number(lastPage) ? "not-allowed" : "pointer",
                                    }}
                                >
                                    Next »
                                </button>
                            </div>
                        )}
                    </>
                )}
            </div>
        </SidebarLayout>
    );
};

export default MyDailyReading;